import { IterationRule } from 'schemas/IterationRule.schema';
import { useQuery } from '@tanstack/react-query';
import { apiFetch } from 'utils/apiUtils';
import useAuth from 'hooks/useAuth.ts';

const STALE_TIME_MS = 60 * 1000 * 5;

interface IFetchTeamDefaultRulesVariables {
  teamId: string,
  staleTimeMs?: number;
}

export default function useFetchTeamDefaultRules({ teamId, staleTimeMs = STALE_TIME_MS }: IFetchTeamDefaultRulesVariables) {
  const { tokens } = useAuth();
  return useQuery({
    queryKey: ['teamDefaults', { teamId }],
    staleTime: staleTimeMs,
    queryFn: async () => apiFetch<IterationRule[]>({
      path: `team/${teamId}/defaultRules`,
      method: 'GET',
      accessToken: String(tokens.accessToken),
    }),
  });
}
